/**
 *  @class
 *  @function SocialShare
 */
class SocialShare {
  constructor() {
    this.container = document.querySelector('.share-article');
    this.links = document.querySelectorAll('.social');
    this.copyLink = document.querySelector('.social-copy-link');

    this.setupEventListeners();
  }
  setupEventListeners() {
    this.links.forEach((link) => {
      link.addEventListener('click', (event) => {
        let left = (screen.width / 2) - (640 / 2),
          top = (screen.height / 2) - (440 / 2) - 100;
        window.open(link.getAttribute('href'), 'mywin', 'left=' + left + ',top=' + top + ',width=640,height=440,toolbar=0');
        event.preventDefault();
      });
    });

    this.copyLink?.addEventListener('click', (event) => {
      event.preventDefault();
      let trigger = event.target.closest('.social-copy-link');
      let triggerLabel = trigger.querySelector('span');
      navigator.clipboard.writeText(event.target.getAttribute('href')??"");
      if(triggerLabel && trigger.dataset.textAfter){
        triggerLabel.innerHTML = trigger.dataset.textAfter;
        setTimeout(function(){
          triggerLabel.innerHTML = trigger.dataset.textBefore;
        }, 3000);
      }
    });
  }
}
window.addEventListener('load', () => {
  if (typeof SocialShare !== 'undefined') {
    new SocialShare();
  }
});